<template>
    <b-modal id="modalInserirComissionamento" v-model="exibir">
        <b-card-header>
            <span class="h5">
                COMISSÃO
                <b-badge variant="warning" class="ml-2">{{ acao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required">Data Inicial</label>

                        <date-picker
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            v-model="dataInicial"
                            :disabled="true"
                        ></date-picker>
                        <b-form-invalid-feedback
                            >O campo Data Inicial é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required">Data Final</label>

                        <date-picker
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            v-model="dataFinal"
                            :disabled="true"
                        ></date-picker>
                        <b-form-invalid-feedback
                            >O campo Data Final é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required">Recorrente</label>
                        <b-form-select
                            :options="recorrenteOpcional"
                            v-model="recorrente"
                            text-field="label"
                            value-field="value"
                        ></b-form-select>
                        <b-form-invalid-feedback
                            >O campo Recorrente é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required"
                            >Valor Percentual da Comissão</label
                        >
                        <money
                            v-model="porcentagemComissao"
                            v-bind="money"
                            class="form-control text-right"
                        ></money>
                        <b-form-invalid-feedback
                            >O campo Valor da Comissão é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="12">
                    <b-form-group>
                        <label class="required">Contrato Comissionado</label>
                        <b-form-select
                            :options="contratosComissionados"
                            v-model="contratoComissionado"
                            text-field="vcObjetoContrato"
                            value-field="idContrato"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback
                            >O campo Contrato Comissionado é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <div slot="modal-footer">
            <b-button
                variant="secondary"
                @click.stop="fecharModal()"
                class="mr-1"
            >
                <span> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmaSalvarComissao()"
                :disabled="desabilitarBtnSalvar"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
    props: {
        comissionamento: {
            type: Object,
            default: () => ({})
        },
        erros: {
            type: Array,
            default: () => []
        },
        exibir: {
            type: Boolean,
            default: () => false
        },
        contratos: {
            type: Array,
            default: () => []
        },
        contrato: {
            type: Object,
            default: () => ({})
        },
        acao: {
            type: String
        }
    },

    data() {
        return {
            exibicao: false,
            recorrente: null,
            porcentagemComissao: null,
            dataInicial: null,
            dataFinal: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: ' %',
                precision: 2,
                masked: true
            },
            contratoComissionado: null,
            contratosComissionados: [],
            recorrenteOpcional: [
                { label: 'Sim', value: true },
                { label: 'Não', value: false }
            ]
        }
    },
    emits: ['salvar', 'atualizar', 'fecharModal'],

    methods: {
        fecharModal() {
            this.erros = []

            this.$emit('fecharModal')
        },

        preencher() {
            this.recorrente = this.comissionamento.recorrente
            this.porcentagemComissao = this.comissionamento.porcentagemComissao
            this.dataInicial = this.$moment(
                this.comissionamento.dataInicio
            ).format('DD/MM/YYYY')
            this.dataFinal = this.$moment(
                this.comissionamento.dataFinal
            ).format('DD/MM/YYYY')
            this.contratoComissionado =
                this.comissionamento.contratoComissionado.idContrato
        },

        confirmaSalvarComissao() {
            this.$swal({
                title: 'Comissionamento',
                html: `Confirmar ${this.acao} da Comissão?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.salvarComissao()
                }
            })
        },

        salvarComissao() {
            let comissionamento = {
                ContratoId: this.$route.params.contratoId,
                DataInicio: this.$moment(this.contrato.dtInicioVigencia).format(
                    'YYYY-MM-DD'
                ),
                DataFinal: this.$moment(this.contrato.dtFimVigencia).format(
                    'YYYY-MM-DD'
                ),
                Recorrente: this.recorrente,
                ContratoComissionadoId: this.contratoComissionado,
                PorcentagemComissao: parseFloat(
                    this.porcentagemComissao
                        .replace(/[^\d.,-]/g, '')
                        .replace(',', '.')
                )
            }

            this.$emit('salvar', comissionamento)
        },

        limparForm() {
            this.dataFinal = null
            this.dataInicial = null
            this.porcentagemComissao = null
            this.recorrente = null
            this.contratoComissionado = null
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {
        exibir() {
            this.exibicao = this.exibir

            if (this.exibicao == false) {
                this.limparForm()
            }
        },
        comissionamento() {
            this.preencher()
        },
        contratos() {
            this.contratosComissionados = this.contratos
        },
        contrato() {
            this.dataInicial = this.$moment(
                this.contrato.dtInicioVigencia
            ).format('DD/MM/YYYY')
            this.dataFinal = this.$moment(this.contrato.dtFimVigencia).format(
                'DD/MM/YYYY'
            )
        }
    },

    validations: {
        dataInicial: {
            required
        },
        dataFinal: {
            required
        },
        recorrente: {
            required
        },
        porcentagemComissao: {
            required
        },
        contratoComissionado: {
            required
        }
    }
}
</script>
